export default __webpack_public_path__ + "static/media/Hanan.94e93752.jpeg";